/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
// import { Typography } from 'antd';
// import { useSelector } from 'react-redux';
// import { RootState } from 'store';
import styled from 'styled-components';
import {
  boxShadow,
  maxTablet,
  maxWidth,
  maxWidth1170,
  minWidthApp,
  primaryColor,
  primaryActiveColor,
  primaryFont,
  primaryHeadingColor,
  retina,
  scrollbar,
  wMedium,
} from 'constants/utilsStyles';
import ContactInfoCard from 'modules/Common/Components/ContactInfoCard';
import PersonalityBulletWidget from 'modules/Common/Components/PersonalityBulletWidget';
import EngagementScorePill from 'modules/Common/Components/EngagementScroePill';
import { ContactStatusClass, TableHeadersSortBy, TableHeading } from 'modules/Audience/constants';
import { Checkbox, Empty, Tooltip } from 'antd';
import { ISortOrder } from 'modules/Audience/interfaces2';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import classNames from 'classnames';
import ContactTileSkeleton from 'modules/Common/Skeleton/ContactTileSkeleton';
import { getContactDetails, getContactDashboard } from 'modules/Campaigns/Audience/actions';
import { openDetailProfile } from 'modules/GlobalActions';
import TableSorting from './TableSorting';
import { IContactItem } from '../../interface';
import ContactsTableAddRemove from './ContactsTableAddRemove';

const InnerTable = styled.div`
 position: relative;
 z-index: 0;
`;

const TableBody = styled.div`
  display: flex;
  align-items: center;
  //box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #FFF;
  width: 100%;
  margin-bottom: 8px;
  padding: 8px 0px 8px 24px;
  cursor: pointer;
  @media all and (max-width: ${minWidthApp}) { 
   padding: 8px 0px 8px 24px;
  }
  &.activeCard {
    outline: 2px solid ${primaryColor}; 
    outline-offset: -2px;
    background: ${primaryActiveColor};
  }
  .table-item {
    text-align: start;
    position: relative;
    padding: 16px 5px;
    .date-time-div {
      display: flex;
      align-items: center;
      width: 100%;
      .text-date{
        width: unset;
        line-height: 15px;
        &:first-child {
          border-right: 1px solid  ${primaryHeadingColor};
          padding-right: 8px;
          margin-right: 8px;
        }
      }
    }
  }
  `;

const TableHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 0px 0px 24px;
  position: sticky;
  top: 0px;
  background-color: #f9f8f6;
  z-index: 2;
  width: 100%;
  @media all and (max-width: ${minWidthApp}) {
    padding: 0px 0px 0px 24px;
  }

  .table-item {
    position: relative;
    &:first-child {
      display: flex;
      .header-aud-title {
        padding-left: 95px;
      }
      .heading-div {
        padding-left: 88px;
      }
    }
    .heading-div {
      &.actionHeading {
        cursor: pointer;
        width: fit-content;
      }
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .heading-text {
        font-family: ${primaryFont};
        font-size: 16px;
        font-weight: ${wMedium};
        line-height: 18px;
        letter-spacing: -0.333px;
        color: #5E7079;
        margin-bottom: 0px;
      }
      .action-div {
        display: flex;
        flex-direction: column;
        margin-left: 5px;
        svg {
          width: 8px;
          height: 8px;
          cursor: pointer;
          &:first-child {
            transform: rotate(180deg);
            margin-bottom: 1px;
          }
        }
      }
    }
  }
`;

const InnerStyleWrapper = styled.div`
  @media all and (max-width: ${minWidthApp}) { 
    overflow-x: scroll;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    ${scrollbar};
    padding: 0 10px;
    @media all and (max-width: ${maxWidth1170}) {
      overflow-x: auto;
    }
    .table-item {
      @media all and (max-width: ${maxTablet}) {
        min-width: 200px;
        &:first-child {
          min-width: 380px;
          max-width: 380px;
        }
      }
    }
  }
`;

const StyledWrapper = styled.div`
  position: relative;
  padding: 0px 10px 0 24px;
  height: 100%;
  @media all and (max-width: ${minWidthApp}) {
    padding: 0px 10px 0 5px;
  }

  &.emptySate {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  .table-width-decide {
    @media all and (max-width: ${minWidthApp}) {
      min-width: calc(100vw + 50px);
    }
  }
  .table-item {
    flex: 1 1 0%;
    padding: 10px 5px;
    &:first-child {
      min-width: 545px;
      max-width: 545px;
      @media all and (max-width :${maxWidth}), ${retina} {
        min-width: 380px;
        max-width: 380px;
      }
    }
  }
  .infinite-scroll-component__outerdiv {
    .infinite-scroll-component {
      display: flex;
      flex-direction: column;
      padding: 5px 30px;
      min-height: calc(100vh - 310px);
      overflow-y: hidden !important;
      &.forLoader {
        min-height: unset;
      }
    }
  }
  .header-aud-title {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    color: #5E7079;
    background: transparent;
    border-bottom: unset;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .title-inner-span {
      cursor: pointer;
      display: flex;
    }
  }
  .checked-item {
    display: flex;
    align-items: center;
    padding-left: 0px;
  }
  .checkbox-div {
   margin: 0px 20px 0px 0px;
  }
  .pl-0 {
    padding-left: 0px !important;
  }
  .engagement-score-wrapper {
    padding-right: 13px;
  }
  .contact-tile-company {
    position: absolute;
    left: 10px;
    top: 0px;
    width: 80%;
  }
`;

interface ISmartTable {
  // lastId: any;
  // dataSource: any;
  // debug: boolean;
  // infinity: boolean;
  // loadingIndicator: boolean;
  // onFetch: () => void;
  // scroll: any;
  // hasMore?: boolean;
  isSearched?: boolean;
  contacts: IContactItem[];
  addToListMode?: boolean;
  selectDisable?: boolean;
  isGlobal?: boolean;
  isListActive?: boolean;
  selectAll: boolean;
  sortOrder: ISortOrder;
  disableSelectAll?: boolean;
  excludedContactsIds: number[];
  holdSelectedIds: number[];
  loading: boolean;
  totalContacts: number;
  isSearchLoading: boolean;
  newContactAdded: boolean;
  refreshLoading: boolean
  handleSingleContact: (type: string, contact: IContactItem) => void;
  handleSetSelectedContacts: (checked: boolean) => void;
  handleSelectContacts: (contact: IContactItem, type?: string) => void;
  updateSortingOrders: (property: keyof ISortOrder) => void;
  updateSortingConfig: (sortBy: string, sortType: string) => void;
}

const defaultProps = {
  // loading: false,
  // isDashboard: false,
  // searchLoading: false,
  isGlobal: false,
  addToListMode: false,
  isListActive: false,
  disableSelectAll: false,
  selectDisable: false,
};

const SmartTable: React.FC<ISmartTable> = ({
  // debug = false,
  // infinity = false,
  // dataSource = [],
  // scroll = scrollConfig,
  // onFetch = () => null,
  // lastId,
  // hasMore,
  isSearched,
  selectDisable,
  sortOrder,
  contacts,
  addToListMode,
  isGlobal,
  isListActive,
  selectAll,
  disableSelectAll,
  excludedContactsIds,
  holdSelectedIds,
  totalContacts,
  loading,
  isSearchLoading,
  newContactAdded,
  refreshLoading,
  handleSingleContact,
  handleSetSelectedContacts,
  handleSelectContacts,
  updateSortingOrders,
  updateSortingConfig,
  // ...props
}) => {
  const selectedListFilter = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.appliedFilters);
  const selectedContactFilter = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.appliedFilters);
  const listFilterApplied = selectedListFilter.designation.length > 0 || selectedListFilter.status.length > 0
    || selectedListFilter.organization.length > 0 || selectedListFilter.personalityType.length > 0;
  const contactFilterApplied = selectedContactFilter.designation.length > 0 || selectedContactFilter.status.length > 0
    || selectedContactFilter.organization.length > 0 || selectedContactFilter.personalityType.length > 0;
  // const { Paragraph } = Typography;

  const checkDisable = (row: IContactItem) => {
    if (addToListMode && isGlobal) {
      return row?.isListContact || isListActive;
    }

    if (addToListMode && !isGlobal) {
      return isListActive;
    }
    return false;
  };

  const convertSortOrder = (sortType: string) => {
    if (sortType === 'ascend') return 'DESC';
    return 'ASC';
  };

  const handleSortClick = (currentSortOrder: keyof ISortOrder, sortContactBy: string, sortContactType: string) => {
    updateSortingOrders(currentSortOrder);
    updateSortingConfig(sortContactBy, sortContactType);
  };

  const handleDetailsClick = (e: MouseEvent, contactId: number) => {
    e?.stopPropagation();
    openDetailProfile();
    getContactDetails(contactId?.toString());
    getContactDashboard(contactId);
  };

  return (
    <StyledWrapper className={classNames({ emptySate: contacts.length === 0 })}>
      <InnerStyleWrapper className="w-100">
        {contacts.length !== 0 && !refreshLoading ? (
          <InnerTable className="table-width-decide">
            <TableHeader className="header-table">
              <span className="table-item first-item-header pl-0">
                <Checkbox
                  disabled={isListActive || disableSelectAll || loading || totalContacts === 0}
                  checked={(selectAll && excludedContactsIds.length === 0) || ((totalContacts === holdSelectedIds.length) && totalContacts !== 0)}
                  onChange={(e) => {
                    handleSetSelectedContacts(e.target.checked);
                  }}
                />
                <span
                  className="header-aud-title"
                >
                  <span
                    className="title-inner-span"
                    onClick={() => {
                      handleSortClick(
                        TableHeading.NAME.toLowerCase() as keyof ISortOrder,
                        TableHeadersSortBy.NAME,
                        convertSortOrder(sortOrder.name as string),
                      );
                    }}
                  >
                    {TableHeading.NAME}
                    <TableSorting sortOrder={sortOrder.name} />
                  </span>

                </span>
              </span>

              <span className="table-item">
                <span
                  className="header-aud-title"
                >
                  <span
                    onClick={() => {
                      handleSortClick(
                        TableHeading.COMPANY.toLowerCase() as keyof ISortOrder,
                        TableHeadersSortBy.COMPANY,
                        convertSortOrder(sortOrder.company as string),
                      );
                    }}
                    className="title-inner-span"
                  >
                    {TableHeading.COMPANY}
                    <TableSorting sortOrder={sortOrder.company} />
                  </span>
                </span>
              </span>

              <span className="table-item">
                <span
                  className="header-aud-title"
                >
                  <span
                    onClick={() => {
                      handleSortClick(
                        TableHeading.PERSONALITY.toLowerCase() as keyof ISortOrder,
                        TableHeadersSortBy.PERSONALITY,
                        convertSortOrder(sortOrder.personality as string),
                      );
                    }}
                    className="title-inner-span"
                  >
                    {TableHeading.PERSONALITY}
                    <TableSorting sortOrder={sortOrder.personality} />
                  </span>
                </span>
              </span>

              <span className="table-item">
                <span
                  className="header-aud-title"
                >
                  <span
                    onClick={() => {
                      handleSortClick(
                        TableHeading.STATUS.toLowerCase() as keyof ISortOrder,
                        TableHeadersSortBy.STATUS,
                        convertSortOrder(sortOrder.status as string),
                      );
                    }}
                    className="title-inner-span"
                  >
                    {TableHeading.STATUS}
                    <TableSorting sortOrder={sortOrder.status} />
                  </span>
                </span>
              </span>
            </TableHeader>
            <>
              {contacts.map((contact: IContactItem, index: number) => (
                <TableBody
                  className={classNames('body-table', { activeCard: holdSelectedIds.includes(contact.contactId) || (newContactAdded && index === 0) })}
                  onClick={(e) => handleDetailsClick(e, contact.contactId)}
                >
                  <span className="table-item checked-item">
                    <div className="checkbox-div">
                      <Checkbox
                        onClick={(e) => e.stopPropagation()}
                        checked={holdSelectedIds.includes(contact.contactId)}
                        disabled={selectDisable || checkDisable(contact)}
                        onChange={(e) => { e.stopPropagation(); handleSelectContacts(contact); }}
                      />
                    </div>
                    <ContactInfoCard contact={contact} />
                  </span>
                  <span className="table-item">
                    <Tooltip title={contact.organization} placement="topLeft">
                      <p className="contact-tile-company text-truncate">{contact.organization}</p>
                    </Tooltip>

                  </span>
                  <span className="table-item"><PersonalityBulletWidget title={contact.personality} color={contact.color} /></span>
                  <span className="table-item">
                    {
                      addToListMode
                        ? (
                          <div className={`status-wrapper block-title-contact-${contact.isListContact.toString()}-${contact.contactId}`}>
                            <p className={`contact-tile-status text-truncate ${ContactStatusClass[(contact?.status)]}`}>{contact?.status}</p>
                            <div className="status-wrapper_inner">
                              <ContactsTableAddRemove
                                isGlobal={isGlobal}
                                clickHandle={(type: string) => handleSingleContact(type, contact)}
                                isListContact={contact.isListContact}
                              />
                              <EngagementScorePill showSideMenu contactId={contact.contactId} index={`${contact.isListContact.toString()}-${contact.contactId}`} targetShow />
                            </div>
                          </div>
                        ) : (
                          <div className="status-wrapper block-title-contact">
                            <p className={`contact-tile-status text-truncate ${ContactStatusClass[(contact?.status)]}`}>{contact?.status}</p>
                            <EngagementScorePill showSideMenu contactId={contact.contactId} index={contact.contactId} />
                          </div>
                        )
                    }

                  </span>
                </TableBody>
              ))}
            </>

          </InnerTable>
        ) : null}
        {contacts.length === 0 && (isSearched ? !isSearchLoading : !loading) && !refreshLoading ? (
          <div className="no-data-found">
            <Empty description={`${isSearched || listFilterApplied || contactFilterApplied ? 'No contact(s) found against your search' : 'Your contact(s) will show up here once you will import a list or create a new contact.'}`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        ) : null}
        {refreshLoading || (isSearched ? isSearchLoading : loading) ? (
          [1, 2, 3].map(() => (
            <div className="loader-wrapper-appear w-100">
              <ContactTileSkeleton />
            </div>
          ))
        ) : null}
      </InnerStyleWrapper>
    </StyledWrapper>
  );
};

SmartTable.defaultProps = defaultProps;

export default SmartTable;
